const CPFB_URL = 'https://www.cpf.gov.sg';
const CPF_URL = 'https://www.cpf.gov.sg';
const HPSTnC_URL = 'https://www.cpf.gov.sg/member/tnc/important-notes-on-home-protection-scheme';


// To refactor: CPFB and CPF should refer to the same
export function CPFBWebsite() {
  return (
    <a href={CPFB_URL} onClick={() => {}} target='_blank' rel='noreferrer' className='polymer-text-links'>
      CPFB’s website
    </a>
  );
}

// Step 3
export function CPFWebsite() {
  return (
    <a href={CPF_URL} onClick={() => {}} target='_blank' rel='noreferrer' className='polymer-text-links'>
      CPFB’s website
    </a>
  );
}

// Step 3
export function HPSTermsAndCondition() {
  return (
    <a href={HPSTnC_URL} onClick={() => {}} target='_blank' rel='noreferrer' className='polymer-text-links'>
      Terms and Conditions on HPS
    </a>
  );
}
